import React from 'react';
import './sidebar.css'
import logo from '../../assets/logo.png'
import Navlink from '../common/nav_but';
import pic1 from '../../assets/pic1.png'
import pic2 from '../../assets/pic2.png'
import pic3 from '../../assets/pic3.png'
import pic4 from '../../assets/pic4.png'
import pic5 from '../../assets/pic5.png'
import pic6 from '../../assets/pic6.png'
import pic7 from '../../assets/pic7.png'
import pic8 from '../../assets/pic8.png'
import pic9 from '../../assets/pic9.png'
import pic10 from '../../assets/pic10.png'
import pic11 from '../../assets/pic11.png'
import pic12 from '../../assets/pic12.png'
import pic14 from '../../assets/pic14.png'
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router-dom';



const Sidebar = ({ isOpen }) => {


 const location = useLocation();
 

const isLandingContentActive =
  location.pathname === "/Event-content_Management-page" ||
  location.pathname === "/Category-content_Management-page"||
  location.pathname === "/About-content_Management-page"||
  location.pathname === "/Navs_content_Management-page"||
  location.pathname === "/Feedback_content_Management-page"||
  location.pathname === "/FAQs_content_Management-page";

    return ( 
        <section className={`sec-cont-side-bar ${isOpen ? 'show' : 'hide'}`} >

        <nav className='sidebar'>
            <article className='box1-side-bar'>
                <img className='logo' src={logo} alt="logo"></img>
                <h3 className='text-box1-side-bar'>Admin Dashboard</h3>
            </article>
            <nav className='container-buttons'>

                <Link to="/home-page">
                <Navlink
                    title='Dashboard'
                    img={pic1}
                    stylee={location.pathname === '/home-page' ? 'activepage-button' : 'noneactivebutton'}
                    stylee2={location.pathname === '/home-page' ? 'active-text' : 'noneactive-text'}
                />
                </Link>


                <Link to="/event-mangement-page">
                    <Navlink
                        title="Events"
                        img={pic2}
                        stylee={location.pathname === '/event-mangement-page' ? 'activepage-button' : 'noneactivebutton'}
                        stylee2={location.pathname === '/event-mangement-page' ? 'active-text' : 'noneactive-text'}
                    />
                </Link>

        
                <Link to="/booking-mangement-page">      
                <Navlink title='Bookings' img={pic3} 
                stylee={location.pathname === '/booking-mangement-page' ? 'activepage-button' : 'noneactivebutton'}
                stylee2={location.pathname === '/booking-mangement-page' ? 'active-text' : 'noneactive-text'}/>
             </Link>  


                <Link to="/Categories_management-page">   
                <Navlink title='Categories' img={pic4} 
                stylee={location.pathname === '/Categories_management-page' ? 'activepage-button' : 'noneactivebutton'}
                stylee2={location.pathname === '/Categories_management-page' ? 'active-text' : 'noneactive-text'}/>
                </Link>

                <Link to="/Users_Management-page">  
                <Navlink title='Users' img={pic5}
                 stylee={location.pathname === '/Users_Management-page' ? 'activepage-button' : 'noneactivebutton'}
                stylee2={location.pathname === '/Users_Management-page' ? 'active-text' : 'noneactive-text'}/>
                </Link>



                <Link to="/Support-Management-page">  
                <Navlink title='Support' img={pic6}
                 stylee={location.pathname === '/Support-Management-page' ? 'activepage-button' : 'noneactivebutton'}
                stylee2={location.pathname === '/Support-Management-page' ? 'active-text' : 'noneactive-text'}/>
                </Link>


                <Link to="/Feedback_Management-page">  
                <Navlink title='Feedback' img={pic7} 
                  stylee={location.pathname === '/Feedback_Management-page' ? 'activepage-button' : 'noneactivebutton'}
                stylee2={location.pathname === '/Feedback_Management-page' ? 'active-text' : 'noneactive-text'}/>
                </Link>

                <Link to="/Event-content_Management-page">          
                    <Navlink
                    title='Landing Content'
                    img={pic8}
                    stylee={isLandingContentActive ? 'activepage-button' : 'noneactivebutton'}
                    stylee2={isLandingContentActive ? 'active-text' : 'noneactive-text'}
                    />

                </Link>



            </nav>

             <nav className='container-buttons2'>
                  <Navlink title='Settings' img={pic14} stylee='noneactivebutton' stylee2='noneactive-text'/>   
                 <Link to="/" className='link'   >
                <Navlink title='Logout' img={pic9} stylee='noneactivebutton' stylee2='noneactive-text'/>    
                </Link>        
            </nav>
            <nav className='container-last-part-sidebar'>
                <nav className='container-notification-lang'>
                                            <button className='cta-hedaer'>
                                        <img src={pic12} alt='pic'></img>
                                        <h2 className="lang">عربي</h2>
                    </button>
                            <button className='button-notification2'>
                                            <img src={pic10} alt='pic'></img>
                        </button>
                </nav>

                                <article className='container-profile'>
                                    <img src={pic11} alt='pic'></img>
                                    <article className='container-text-profile'>
                                        <h2 className='admintext'>Admin User</h2>
                                        <h3 className='adminemail'>admin@musicticket.com</h3>
                                    </article>
                                </article>
                

            </nav>
        </nav>
        </section>
     );
}
 
export default Sidebar;